import { EnvironmentService } from './environment.service';

export const environmentFactory = (environmentService: EnvironmentService) => {
  return (): Promise<void> => environmentService.loadConfig();
};
